// named export (recommended)

export const BLOG_page = {
    blogData: {
        sectionId: "Make journey comfortable with",
        title: "Explore our categories",
        subtitle: "Make journey comfortable with",
        image: {
            src: "/img/personal-chauffeur/section2.svg",
            alt: " Hands offering coins"
        },
        button: { text: "Book Now", link: "#" },
        bgcolor: "#fff",
        listData: [
            {
                slug: "design-tips-cover-everything",
                image: "/img/blog/bloglist/card1.svg",
                category: "STARTUP",
                title: "Design tips for designers that cover everything you need",
                excerpt:
                    "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.",
                author: { name: "Jane Doe", avatar: "/img/blog/avatar1.png" },
                dateISO: "2025-08-22",
                content: [
                    {
                        type: "title",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "title",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "bullets",
                        value: ["Lorem ipsum dolor sit amet", "Non blandit massa enim nec scelerisque", "Neque egestas congue quisque egestas"]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "title",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    }
                ]
            },
            {
                slug: "rapport-with-web-clients",
                image: "/img/blog/bloglist/card2.svg",
                category: "BUSINESS",
                title: "How to build rapport with your web design clients",
                excerpt:
                    "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.",
                author: { name: "John Doe", avatar: "/img/blog/avatar2.png" },
                dateISO: "2025-08-22",
                content: [
                    {
                        type: "title",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "title",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "bullets",
                        value: ["Lorem ipsum dolor sit amet", "Non blandit massa enim nec scelerisque", "Neque egestas congue quisque egestas"]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "title",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    }
                ]
            },
            {
                slug: "logo-design-trends-2022",
                image: "/img/blog/bloglist/card3.svg",
                category: "STARTUP",
                title: "Logo design trends to avoid in 2022",
                excerpt:
                    "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.",
                author: { name: "Jane Doe", avatar: "/img/blog/avatar1.png" },
                dateISO: "2025-08-22",
                content: [
                    {
                        type: "title",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "title",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "bullets",
                        value: ["Lorem ipsum dolor sit amet", "Non blandit massa enim nec scelerisque", "Neque egestas congue quisque egestas"]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "title",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    }
                ]
            },
            {
                slug: "8-figma-design-systems-free",
                image: "/img/blog/bloglist/card4.svg",
                category: "TECHNOLOGY",
                title: "8 Figma design systems you can download for free today",
                excerpt:
                    "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.",
                author: { name: "John Doe", avatar: "/img/blog/avatar2.png" },
                dateISO: "2025-08-22",
                content: [
                    {
                        type: "title",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "title",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "bullets",
                        value: ["Lorem ipsum dolor sit amet", "Non blandit massa enim nec scelerisque", "Neque egestas congue quisque egestas"]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "title",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    }
                ]
            },
            {
                slug: "font-sizes-ui-complete-guide",
                image: "/img/blog/bloglist/card1.svg",
                category: "ECONOMY",
                title: "Font sizes in UI design: The complete guide to follow",
                excerpt:
                    "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.",
                author: { name: "Jane Doe", avatar: "/img/blog/avatar1.png" },
                dateISO: "2025-08-22",
                content: [
                    {
                        type: "title",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "title",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "bullets",
                        value: ["Lorem ipsum dolor sit amet", "Non blandit massa enim nec scelerisque", "Neque egestas congue quisque egestas"]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    },
                    {
                        type: "title",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod."]
                    },
                    {
                        type: "description",
                        value: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Non blandit massa enim nec. Scelerisque viverra mauris in aliquam sem. At risus viverra adipiscing at in tellus. Sociis natoque penatibus et magnis dis parturient montes. Ridiculus mus mauris vitae ultricies leo. Neque egestas congue quisque egestas diam. Risus in hendrerit gravida rutrum quisque non."]
                    }
                ]
            },
        ]
    },
    ourPackage: {
        sectionId: "Make journey comfortable with",
        title: "Our Packages",
        subtitle: "Looking for something?",
        image: {
            src: "/img/personal-chauffeur/section2.svg",
            alt: " Hands offering coins"
        },
        pricingData: [
            {
                "plan": "Basic plan",
                "price": "$20",
                "per": "/month",
                "billingNote": "Billed annually.",
                "icon": "/img/personal-chauffeur/icon.svg",
                "features": [
                    "Access to all basic features",
                    "Basic reporting and analytics",
                    "Up to 10 individual users",
                    "20GB individual data each user",
                    "Basic chat and email support"
                ],
                "ctaText": "Get started"
            },
            {
                "plan": "Standard plan",
                "price": "$20",
                "per": "/month",
                "billingNote": "Billed annually.",
                "icon": "/img/personal-chauffeur/icon.svg",
                "features": [
                    "Access to all basic features",
                    "Basic reporting and analytics",
                    "Up to 10 individual users",
                    "20GB individual data each user",
                    "Basic chat and email support"
                ],
                "ctaText": "Get started"
            },
            {
                "plan": "Premium plan",
                "price": "$20",
                "per": "/month",
                "billingNote": "Billed annually.",
                "icon": "/img/personal-chauffeur/icon.svg",
                "features": [
                    "Access to all basic features",
                    "Basic reporting and analytics",
                    "Up to 10 individual users",
                    "20GB individual data each user",
                    "Basic chat and email support"
                ],
                "ctaText": "Get started"
            }
        ],
        button: { text: "Book Now", link: "#" },
        bgcolor: "#fff",
    },
    carToInvest: {
        sectionId: "Make journey comfortable with",
        title: "Benefits Of Collaborating With RSL",
        subtitle:
            "Make journey comfortable with",
        image: {
            src: "/img/investments/collaborate/benefits.svg",
            alt: " Hands offering coins"
        },
        button: { text: "Let's work together", link: "#" },
        bgcolor: "#fff",
    },
    communicationChannel: {
        sectionId: "communicationChannel",
        image: {
            src: "/images/bannerImage/rsl_super_app.svg",
            alt: "RSL SUPER APP"
        }
    }
}